export { ColorContextProvider, useColorContext } from './ColorContext';
